import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classes from './ReportStatusBadge.module.css';

const ReportStatusBadge = () => {
	const { isGenerating, startTime } = useSelector((state) => state.reportStatus);
	const [elapsedTime, setElapsedTime] = useState('');

	// Update elapsed time every second
	useEffect(() => {
		if (!isGenerating || !startTime) {
			return;
		}

		const updateElapsedTime = () => {
			const now = Date.now();
			const elapsed = Math.floor((now - startTime) / 1000);
			const minutes = Math.floor(elapsed / 60);
			const seconds = elapsed % 60;
			
			if (minutes > 0) {
				setElapsedTime(`${minutes}m ${seconds}s`);
			} else {
				setElapsedTime(`${seconds}s`);
			}
		};

		// Update immediately
		updateElapsedTime();

		// Then update every second
		const interval = setInterval(updateElapsedTime, 1000);

		return () => clearInterval(interval);
	}, [isGenerating, startTime]);

	// Don't render if not generating
	if (!isGenerating) {
		return null;
	}

	return (
		<div className={classes.badge} title="Report is generating">
			<div className={classes.spinnerContainer}>
				<div className={classes.spinner}></div>
			</div>
			<div className={classes.content}>
				<div className={classes.title}>Report Generating</div>
				<div className={classes.time}>{elapsedTime}</div>
			</div>
		</div>
	);
};

export default ReportStatusBadge;
